import React from "react";
import fetch from "unfetch";
import ForgeryProtection from "lib/ForgeryProtection";
import { setContext } from "@apollo/client/link/context";
import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  InMemoryCache
} from "@apollo/client";

/* eslint-disable import/prefer-default-export */

const httpLink = createHttpLink({
  uri: "/api/graphql",
  fetch,
});

const authLink = setContext(async (_, { headers }) => {
  const { token } = await ForgeryProtection.CSRF;

  return {
    headers: {
      ...headers,
      "X-CSRF-Token": token,
    },
  };
});

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

// Use this for any containers which want to make GraphQL queries
// via apollo client.
//
// Example usage:
//
//    import { withApolloProvider } from "lib/apolloClient";
//
//    const someNode = document.getElementById("foo");
//    const reactElement = React.createElement(withApolloProvider(YourReactComponent));
//
//    ReactDOM.render(reactElement, someNode);
//
export const withApolloProvider = Component => props => (
  <ApolloProvider client={apolloClient} >
    <Component {...props} />
  </ApolloProvider>
);
